import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { AuthForm } from '@/components/auth/AuthForm';

export function AuthPage() {
  const [activeTab, setActiveTab] = useState('login');
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const from = location.state?.from?.pathname || '/dashboard';

  useEffect(() => {
    if (user && !loading) {
      navigate(from, { replace: true });
    }
  }, [user, loading, navigate, from]);

  const handleAuthSuccess = () => {
    if (activeTab === 'signup') {
      navigate('/auth/verify');
    } else {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="container relative min-h-[calc(100vh-4rem)] flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0">
      <div className="relative hidden h-full flex-col bg-muted p-10 text-white lg:flex dark:border-r">
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-500 to-indigo-700" />
        <div className="relative z-20 flex items-center text-lg font-medium">
          <Sparkles className="mr-2 h-6 w-6" />
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="relative z-20 mt-auto"
        >
          <blockquote className="space-y-2">
            <p className="text-lg leading-relaxed">
              "I've analysed 10,453,927 video creation platforms and SmartReel is
              definitely in my top 3. It's like having a professional video team, but without
              the coffee breaks and existential discussions about lighting."
            </p>
            <footer className="text-sm opacity-90">
              <p className="font-semibold">ChatGPT</p>
              <p className="text-sm opacity-80">AI Assistant (who definitely wasn't paid to say this)</p>
            </footer>
          </blockquote>
        </motion.div>
      </div>
      <div className="lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
          <AuthForm 
            mode={activeTab === 'login' ? 'login' : 'register'} 
            onModeChange={(mode) => setActiveTab(mode === 'login' ? 'login' : 'signup')}
            onSuccess={handleAuthSuccess}
          />
        </div>
      </div>
    </div>
  );
}